import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Button, Paper } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
	getGroup,
	// getAllGroups,
} from '../../actions/contacts/groups'
import ActionType from '../../actions/ActionType'
import language from 'utils/vast-languagepack'
import Panels from './Panels'
import { getContactsWithEmails } from 'actions/contacts'
import { Person } from '@material-ui/icons'
import { AccountOff } from 'mdi-material-ui'
import GroupName from './GroupName'
import AddContactSelect from './AddContactSelect'
import BulkUploadDialog from '../ContactsPage/BulkUploadDialog'
import { openBulkUploadDialog } from '../../actions/contacts/addOrEdit'

const mapStateToProps = (state, { match }) => {
	const groupID = match.params.groupID ? match.params.groupID : null

	return {
		groupID,
		groupBool: Boolean(state.contacts.groupsByID?.[groupID]),
		count: Object.keys(state.contacts.groupsByID?.[groupID]?.memberIDs || {})
			?.length,
	}
}

const mapDispatchToProps = (dispatch) => {
	const { Contacts } = ActionType
	const dispatchType = (type, payload) => (dispatch) =>
		dispatch({ type, payload })
	return bindActionCreators(
		{
			receiveGroup: (payload) => dispatchType(Contacts.RECEIVE_GROUP, payload),
			getGroup,
			openBulkUploadDialog,
			getContactsWithEmails,
			// getAllGroups,
		},
		dispatch,
	)
}

const styles = (theme) => ({
	content: {
		padding: 24,
		[theme.breakpoints.down('xs')]: {
			padding: 16,
		},
	},
})

class AddOrEditGroupPage extends Component {
	componentDidMount() {
		const { getGroup, groupID, receiveGroup, getContactsWithEmails } =
			this.props

		getContactsWithEmails()

		if (groupID !== 'new') {
			getGroup(groupID).then((payload) => receiveGroup(payload))
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.groupID !== prevProps.groupID) {
			this.props
				.getGroup(this.props.groupID)
				.then((payload) => this.props.receiveGroup(payload))
		}
	}

	componentWillUnmount() {
		this.props.receiveGroup({})
	}

	render() {
		const { classes, groupID, location, history, count, groupBool, openBulkUploadDialog } = this.props

		const Icon = count ? Person : AccountOff

		if (groupID === 'new' || groupBool /*  && groups[groupID].loadStatus */) {
			return (
				<div className={classes.content}>
					{groupID ? <BulkUploadDialog uploadToGroupId={groupID} /> : null}
					<Paper
						style={{
							border: '1px solid #adadad',
							padding: 20,
							borderRadius: 35,
							minHeight: 550,
						}}
					>
						<p
							style={{
								color: 'rgba(0, 0, 0, 0.87)',
								fontSize: '1.5rem',
								fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
								fontWeight: '400',
								lineHeight: '1.33',
								letterSpacing: '0em',
							}}
						>
							{groupID === 'new'
								? language.groups.groupCallToActions.groupNameHeading
								: 'Group name:'}
						</p>
						<div style={{ position: 'relative' }}>
							<GroupName
								groupID={groupID}
								location={location}
								history={history}
							/>
							{groupID !== 'new' && (
								<>
									<p
										style={{
											color: 'rgba(0, 0, 0, 0.87)',
											fontSize: '1.5rem',
											fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
											fontWeight: '400',
											lineHeight: '1.33',
											letterSpacing: '0em',
										}}
									>
										{language.groups.groupCallToActions.groupContactHeading}
									
									</p>
									<div style={{ position: 'relative' }}>
										<AddContactSelect groupID={groupID} />
										<div
											style={{
												position: 'absolute',
												fontSize: 14,
												color: '#6b6b6b',
												whiteSpace: 'nowrap',
												right: 5,
											}}
										>
											<Icon
												style={{
													verticalAlign: 'middle',
													marginRight: 5,
													marginBottom: 2,
												}}
											/>
											{`${count} Contact${count === 1 ? '' : 's'}`}
										</div>
									</div>
									<Button onClick={() => openBulkUploadDialog()}><Person /> Upload Contacts</Button>

								</>
							)}
							<br />

							<Panels groupID={groupID} />
						</div>
					</Paper>
				</div>
			)
		}
		return <CircularProgress />
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withStyles(styles)(AddOrEditGroupPage))
